import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
    setCompanyInfos,
    setEmptyCompany,
    setSelectedCompany,
} from "../actions/company.actions";
import { StorageUtilsService } from "app/services/storage-utils/storage-utils.service";
import { setSelectedClientAccountId } from "../actions/client-account.actions";
import { AppContextModel } from "@store/models/context-model";

@Injectable()
export class CompanyEffect {
    actions$ = inject(Actions);
    _router = inject(Router);
    _storageUtilsService = inject(StorageUtilsService);

    /** set selected company effect */
    setSelectedCompanyEff$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(setSelectedCompany),
            map((action) => action.selectedCompany),
            switchMap((selectedCompany) => {
                /** get selected client account id */
                const accountId = this.getClienAccountId({ selectedCompany });
                /** set selected folder value in storage */
                this._storageUtilsService.setSelectedFolder(selectedCompany);
                return of(
                    setSelectedClientAccountId({ selectedClientAccountId: accountId }),
                );
            }),
        );
    });

    /** set selected company infos (privileges) effect */
    setSelectedCompanyInfosPrivileges = createEffect(() => {
        return this.actions$.pipe(
            ofType(setCompanyInfos),
            map((action) => action),
            switchMap((selectedCompanyInfos) => {
                /** get selected client account id */
                const accountId = this.getClienAccountId({ selectedCompany: selectedCompanyInfos?.selectedCompany, });
                /** set selected folder value in storage */
                this._storageUtilsService.setSelectedFolder(
                    selectedCompanyInfos?.selectedCompany,
                );
                /** set selected privileges on storage  */
                this._storageUtilsService.setCompanyPermission([
                    selectedCompanyInfos?.selectedCompanyPrivileges,
                ]);
                return of(
                    setSelectedClientAccountId({ selectedClientAccountId: accountId }),
                );
            }),
        );
    });


    /** set empty folder */
    setEmptyFolderEff$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(setEmptyCompany),
            map((action) => action.clientAccountId),
            switchMap((clientAccountId) => {
                this._storageUtilsService.removeSelectedFolder();
                /** set client account & fetch subscription for it */
                return of(setSelectedClientAccountId({ selectedClientAccountId: clientAccountId }),);
            }),
        );
    });

    /** save selected company on storage */
    getClienAccountId({ selectedCompany }: { selectedCompany }): number {
        const context = this._storageUtilsService.getAppContext();
        const accounIdFromStorage =
            this._storageUtilsService.getSelectedAccountId();
        const accounId =
            context === AppContextModel.globalContext
                ? selectedCompany?.accountId
                : accounIdFromStorage;
        return accounId;
    }
}
